export default __webpack_public_path__ + "static/media/Zero-Touch-Production.d47961d6.svg";